import { environment } from '../../../../environments/environment';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { LoaderService } from '../../../shared/services/loader.service';
import { DataTableTranslations, DataTableResource, DataTable, DataTableParams, DataTablePagination } from 'angular-datatables-all-versions';
import { DonationService } from '../../../shared/services/donation.service';
import { Donation } from '../../../shared/models/donation.model';
import { FilterDonationComponent } from './filter-donation/filter-donation.component';
import { NgDataTableSortFormatterUtility } from '../../../shared/common/tools/ngdatatablesort-formatter.utility';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';


@Component({
  selector: 'app-donations-list',
  templateUrl: './donations-list.component.html',
  styleUrls: ['./donations-list.component.css']
})
export class DonationsListComponent implements OnInit {

  @ViewChild('dataTable', { static: false }) dataTable: DataTable;
  @ViewChild('search_input', { static: true }) searchInputRef: ElementRef;
  public site_url: string;
  public isCompany = false;
  public isQuick = false;
  public isImpact = false;
  public donations_filtered: Donation[] = [];
  public associations: any[];
  public donations_count = 0;
  public donationsResource: DataTableResource<Object>;
  public filter: string;
  public limits = [25, 50, 100];

  private donations: Donation[] = [];
  private searchParams: SearchParam;
  private routeParams: DataTableParams;
  private ngDataTableSortFormatterUtility = new NgDataTableSortFormatterUtility();

  public translations = <DataTableTranslations>{
    indexColumn: 'Num.',
    expandColumn: 'Infos.',
    selectColumn: 'Sélectionner',
    paginationLimit: 'Max.',
    paginationText: 'Résultats: {from} - {to} / {total}',
    paginationTotalPages: '/'
  }

  constructor(private route: ActivatedRoute, public router: Router, private donationService: DonationService,
    private loaderService: LoaderService, private modalService: NgbModal) {
    this.isCompany = 'company' === route.snapshot.paramMap.get('type');
    this.isQuick = 'quick' === route.snapshot.paramMap.get('type');
    this.isImpact = 'impact' === route.snapshot.paramMap.get('type');
    this.associations = this.route.snapshot.data['assocsForFilter'];
    this.associations.sort((a, b) => a.name.localeCompare(b.name));
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    this.site_url = environment.base_url;
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit() { }

  reload(params) {
    this.loaderService.show();
    params['type'] = this.isQuick ? 3 : this.isCompany ? 1 : this.isImpact ? 4 : 2;
    params['simple'] = this.searchInputRef.nativeElement.value;
    if (this.searchParams) {
      params['search'] = this.searchParams;
    }
    this.routeParams = params;
    if (this.isQuick) {
      this.donationService.quickList(params).subscribe(
        data => {
          this.donations = data.quick_charity_donations;
          this.donations_filtered = data.quick_charity_donations;
          this.donations_count = data.meta.pagination.total_objects;

          this.donations_filtered = this.donations_filtered.sort((item1, item2) => {
            const sortAsc = params['sortAsc'];
            const fieldToSort = params['sortBy'];
            let firstVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item1);
            let secondVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item2);

            firstVal = firstVal ? typeof firstVal === 'string' ? firstVal.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') : firstVal : '';
            secondVal = secondVal ? typeof secondVal === 'string' ? secondVal.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') : secondVal : '';

            if (fieldToSort === 'created_at' || fieldToSort === 'payment.updated_at') {
              firstVal = new Date(firstVal);
              secondVal = new Date(secondVal);
            }

            return sortAsc ?
              firstVal < secondVal ? -1 : firstVal > secondVal ? 1 : 0
              :
              firstVal < secondVal ? 1 : firstVal > secondVal ? -1 : 0;
          });
          this.loaderService.hide();
        }
      )
    } else {
      this.donationService.list(params).subscribe(
        data => {
          this.donations = data.charity_donations;
          this.donations_filtered = data.charity_donations;
          this.donations_count = data.meta.pagination.total_objects;

          if (this.isCompany) {
            this.donations_filtered = this.donations_filtered.filter(item => item.donated_by.entreprise !== null);
          }

          this.donations_filtered = this.donations_filtered.sort((item1, item2) => {
            const sortAsc = params['sortAsc'];
            const fieldToSort = params['sortBy'];
            let firstVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item1);
            let secondVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item2);

            firstVal = firstVal ? typeof firstVal === 'string' ? firstVal.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : firstVal : '';
            secondVal = secondVal ? typeof secondVal === 'string' ? secondVal.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : secondVal : '';

            if (fieldToSort === 'created_at' || fieldToSort === 'payment.updated_at') {
              firstVal = new Date(firstVal);
              secondVal = new Date(secondVal);
            }

            return sortAsc ?
              firstVal < secondVal ? -1 : firstVal > secondVal ? 1 : 0
              :
              firstVal < secondVal ? 1 : firstVal > secondVal ? -1 : 0;
          });
          this.loaderService.hide();
        }
      )
    }
  }

  onSearch() {
    // this.dataTable.offset = 0;
    const search = {
      limit: this.dataTable.limit,
      offset: this.dataTable.offset,
      search: this.searchParams,
      sortAsc: this.dataTable.sortAsc,
      sortBy: this.dataTable.sortBy,
      type: this.isQuick ? 3 : this.isCompany ? 1 : this.isImpact ? 4 : 2,
      simple: this.searchInputRef.nativeElement.value
    }
    this.reload(search);
  }

  onSearchAdvanced() {
    const modalRef = this.modalService.open(FilterDonationComponent);
    modalRef.componentInstance.assocsForFilter = this.associations;
    modalRef.result.then((result) => {
      if (result.hasOwnProperty('status')) {
        this.searchParams = Object.assign({}, {
          created_from: moment.utc(result['created_from']).local().startOf('day').format(),
          created_to: moment.utc(result['created_to']).local().endOf('day').format(),
          email: result['email'],
          status: result['status'],
          assoc: result['assoc']
        });
        // this.dataTable.offset
        const search = {
          limit: this.dataTable.limit,
          offset: this.dataTable.offset,
          search: this.searchParams,
          sortAsc: this.dataTable.sortAsc,
          sortBy: this.dataTable.sortBy,
          type: this.isQuick ? 3 : this.isCompany ? 1 : this.isImpact ? 4 : 2,
          simple: undefined
        }
        this.reload(search);
      }
    }, err => console.log(err));
  }

  onExportData() {
    this.routeParams.limit = this.donations_count;
    const exportdata: any[] = [];

    if (this.isQuick) {
      this.donationService.quickList(this.routeParams).subscribe(
        data => {
          const donations: Donation[] = data.quick_charity_donations;
          donations.filter(don => don.donated_by.entreprise === null).forEach((item: Donation) => {
            const input = {
              'Nom': item.donated_by.name,
              'Prénom': item.donated_by.firstname,
              'Date de naissance': moment(item.donated_by['birth_date']).format('DD/MM/YYYY'),
              'Adresse e-mail': item.donated_by.email,
              'Association soutenue': item.donated_to.assoc.name,
              'Programme': this.potTypeLabel(item.donated_to['pot_type']),
              'Montant du don': item.amount,
              'Pourboires': item.gift_gandee,
              'Frais de service (HT)': (item.service_fee / 1.2).toFixed(2),
              'TVA (20%)': (item.service_fee > 0 ? (item.service_fee - (item.service_fee / 1.2)).toFixed(2)  : (item.amount * 0.04 * 0.2).toFixed(2)),
              'Type': this.getPaymentType(item),
              'ID PAYIN': item['payment'].payin_id,
              'Date de participation': moment(item.created_at).format('DD/MM/YYYY'),
              'Date de dernière mise à jour': moment(item['payment'].updated_at).format('DD/MM/YYYY'),
              'Date de paiement succès': item.payment_success_date ? moment(item.payment_success_date).format('DD/MM/YYYY') : '',
              'URL cagnotte': 'https://www.gandee.com/participate/' + item.donated_to.id
            }

            exportdata.push(input);
          });
          this.downloadFile(exportdata);
        }
      )
    }
    else {
      this.donationService.list(this.routeParams).subscribe(
        data => {
          const donations: Donation[] = data.charity_donations;
          if (this.isCompany) {
            donations.filter(don => don.donated_by.entreprise !== null).forEach((item: Donation) => {
              const input = {
                'Dénomination sociale': item.donated_by.name,
                'Siège social': item.donated_by['user_adress']['address_line_1'],
                'Siren': item.donated_by.entreprise.siren,
                'Forme légale': item.donated_by.entreprise.legal_form,
                'CCP': (item.donated_by['user_adress'] && item.donated_by['user_adress']['post_code']) ?
                  item.donated_by['user_adress']['post_code'] : '',
                'Ville': (item.donated_by['user_adress'] && item.donated_by['user_adress']['city']) ?
                  item.donated_by['user_adress']['city'] : '',
                'Pays': (item.donated_by['user_adress'] && item.donated_by['user_adress']['country_iso']) ?
                  item.donated_by['user_adress']['country_iso'] : '',
                'Contact': item.donated_by.name + ' ' + item.donated_by.firstname,
                'Représentant légal': item.donated_by.entreprise.representative.name + ' ' + item.donated_by.entreprise.representative.firstname,
                'Adresse e-mail': item.donated_by.email,
                'Téléphone': item.donated_by.mob_phone,
                'Association soutenue': item.donated_to.assoc.name,
                'Programme': this.potTypeLabel(item.donated_to['pot_type']),
                'Montant du don': item.amount,
                'Montant comm.': item.gift_gandee,
                'Frais de service (HT)': (item.service_fee / 1.2).toFixed(2),
                'Comm. HT': (item.gift_gandee / 1.2).toFixed(2),
                'TVA (20%)': (item.service_fee > 0 ? (item.service_fee - (item.service_fee / 1.2)).toFixed(2) : 0.000.toFixed(2)),
                'Reference CERFA': this.getFilename(item.cerfa_pdf),
                'Montant CERFA': item.amount,
                'Date CERFA': item.payment_success_date ? moment(item.payment_success_date).format('DD/MM/YYYY') : '',
                'Type': this.getPaymentType(item),
                'ID PAYIN': item['payment'].payin_id,
                'Date de participation': moment(item.created_at).format('DD/MM/YYYY'),
                'Date de dernière mise à jour': moment(item['payment'].updated_at).format('DD/MM/YYYY'),
                'Date de paiement succès': item.payment_success_date ? moment(item.payment_success_date).format('DD/MM/YYYY') : '',
                'URL cagnotte': 'https://www.gandee.com/participate/' + item.donated_to.id
              }

              exportdata.push(input);
            });
            this.downloadFile(exportdata);
          } else {
            donations.filter(don => don.donated_by.entreprise === null).forEach((item: Donation) => {
              const input = {
                'Civilité': item.donated_by['civility'] ? this.getCivility(item.donated_by['civility']) : '',
                'Nom': item.donated_by.name,
                'Prénom': item.donated_by.firstname,
                'Adresse': item.donated_by['user_adress']['address_line_1'],
                'CCP': (item.donated_by['user_adress'] && item.donated_by['user_adress']['post_code']) ?
                  item.donated_by['user_adress']['post_code'] : '',
                'Ville': (item.donated_by['user_adress'] && item.donated_by['user_adress']['city']) ?
                  item.donated_by['user_adress']['city'] : '',
                'Pays': (item.donated_by['user_adress'] && item.donated_by['user_adress']['country_iso']) ?
                  item.donated_by['user_adress']['country_iso'] : '',
                'Date de naissance': moment(item.donated_by['birth_date']).format('DD/MM/YYYY'),
                'Adresse e-mail': item.donated_by.email,
                'Téléphone': item.donated_by.mob_phone,
                'Association soutenue': item.donated_to.assoc.name,
                'Programme': this.potTypeLabel(item.donated_to['pot_type']),
                'Montant du don': item.amount,
                'Frais de service (HT)': (item.service_fee / 1.2).toFixed(2),
                'TVA (20%)': (item.service_fee > 0 ? (item.service_fee - (item.service_fee / 1.2)).toFixed(2)  : (item.amount * 0.04 * 0.2).toFixed(2)),
                'Pourboires': item.gift_gandee,
                'Reference CERFA': this.getFilename(item.cerfa_pdf),
                'Montant CERFA': item.amount,
                'Date CERFA': item.payment_success_date ? moment(item.payment_success_date).format('DD/MM/YYYY') : '',
                'Type': this.getPaymentType(item),
                'ID PAYIN': item['payment'].payin_id,
                'Date de participation': moment(item.created_at).format('DD/MM/YYYY'),
                'Date de dernière mise à jour': moment(item['payment'].updated_at).format('DD/MM/YYYY'),
                'Date de paiement succès': item.payment_success_date ? moment(item.payment_success_date).format('DD/MM/YYYY') : '',
                'URL cagnotte': 'https://www.gandee.com/participate/' + item.donated_to.id
              }

              exportdata.push(input);
            });
            this.downloadFile(exportdata);
          }
        }
      );
    }
  }


  private downloadFile(exportdata) {
    const csvData = this.convertToCSV(exportdata);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const filename = 'export-don_' + moment().toISOString() + '.csv';
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, filename);
    } else {
      const a = window.document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }

  private convertToCSV(objArray) {
    const replacer = (_key, value) => value === null ? '' : value
    const header = Object.keys(objArray[0])
    let csv = objArray.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(';'))
    csv.unshift(header.join(';'));
    csv = csv.join('\r\n')
    return csv;
  }

  private getCivility(input: string): string {
    return input === 'male' ? 'M.' : 'Mme';
  }

  public potTypeLabel(potType: string): string {
    if (potType === 'IMPACT') { return 'SFI'; }
    if (potType === 'CITIZEN_SILVER') { return 'CFI'; }
    return 'Gandee';
  }

  private getPaymentType(item): string {
    let paymentType = '';
    if (item['payment'].type) {
      if (item['payment'].type === 'MANDATE'){
        paymentType = 'Mandat';
      } else if (item['payment'].type === 'CARD'){
        paymentType = 'CB';
      } else if (item['payment'].type === 'BANK_WIRE'){
        paymentType = 'SEPA';
      } else if (item['payment'].type === 'n/a' && item.mandate_id && item.mandate_id !== ''){
        paymentType = 'Mandat';
      }
    }
    return paymentType;
  }

  private getFilename(cerfa_url) {
    if (cerfa_url) {
      if (cerfa_url.url) {
        let filename = cerfa_url.url.split('/').pop();
        filename = filename.substr(0, filename.lastIndexOf('.'));
        filename = filename.replace(/_/g, '-');
        return filename;
      }
    }
  }

}

interface SearchParam {
  created_from: string;
  created_to: string;
  email: string;
  status: string;
}
